export const aiAnalysisLocales = {
  en: {
    aiAnalysis: {
      open: "AI analysis",
      title: "AI analysis",
      contextTitle: "AI analysis · {{module}}",
      hubTitle: "AI analysis",
      hubSubtitle: "Analyses prepared for every module. They run once an AI provider is connected.",
      module: "Module",
      openHub: "All AI analyses",
      analyze: "Analyze",
      privacy: "Only aggregate numbers are sent to the AI: no record rows, names or contact details.",
      dataPreview: "Data that will be sent",
      showPayload: "Show request",
      hidePayload: "Hide request",
      loading: "Preparing data summary…",
      loadError: "Some data could not be loaded.",
      noData: "No records yet",
      records: "{{count}} records",
      last30: "Last 30 days: {{count}}",
      range: "{{from}} – {{to}}",
      byStatus: "By status",
      byGroup: "By group",
      status: {
        disabled: "AI connection waiting",
        no_provider: "AI provider not connected",
        no_consent: "AI data processing consent needed",
        ready: "Ready"
      },
      statusDesc: {
        disabled: "AI analyses are prepared but switched off. They will run here once an administrator connects an AI provider.",
        no_provider: "AI analyses are switched on, but no AI provider is connected yet.",
        no_consent: "Allow AI data processing in Settings to run analyses.",
        ready: "Analyses can run."
      },
      admin: {
        title: "AI connection (administrator)",
        switch: "Enable AI analyses",
        hint: "Analyses run only when this switch is on and a provider is connected. No provider is connected yet.",
        provider: "Provider",
        providerNone: "Not connected",
        saved: "Setting saved.",
        saveError: "The setting could not be saved."
      },
      modules: {
        dashboard: "Overview",
        files: "Documents",
        accounting: "Accounting",
        inventory: "Inventory",
        procurement: "Procurement",
        sales: "Sales",
        manufacturing: "Manufacturing",
        quality: "Quality",
        export: "Export",
        afterSales: "After-sales",
        enterprise: "Enterprise",
        support: "Support"
      },
      datasets: {
        invoices: "Invoices",
        accounts: "Accounts",
        approvals: "Approvals",
        products: "Products",
        stockMovements: "Stock movements",
        warehouses: "Warehouses",
        suppliers: "Suppliers",
        purchaseOrders: "Purchase orders",
        rfqs: "RFQs",
        customers: "Customers",
        salesOrders: "Sales orders",
        productionPlans: "Production plans",
        manufacturingOrders: "Manufacturing orders",
        inspections: "Inspections",
        nonConformances: "Non-conformances",
        exportOrders: "Export orders",
        internationalShipments: "International shipments",
        customsDeclarations: "Customs declarations",
        returns: "Returns",
        rmas: "RMAs",
        warranties: "Warranties",
        serviceOrders: "Service orders",
        files: "Files",
        supportTickets: "Support tickets"
      },
      fields: {
        totalAmount: "Total amount",
        taxAmount: "Tax",
        balance: "Balance",
        amount: "Amount",
        currentStock: "Stock on hand",
        costPrice: "Cost price",
        quantity: "Quantity",
        plannedQty: "Planned qty",
        completedQty: "Completed qty",
        scrappedQty: "Scrapped qty",
        dutiesAmount: "Duties",
        size: "Size (bytes)"
      },
      analyses: {
        executiveSummary: { title: "Executive summary", desc: "A plain-language summary of sales, purchasing, receivables and stock for the period." },
        riskRadar: { title: "Risk radar", desc: "Overdue invoices, stuck approvals and open quality issues ranked by impact." },
        documentInsights: { title: "Document insights", desc: "What kinds of documents arrive, how fast they are processed and which need attention." },
        duplicateDocuments: { title: "Duplicate documents", desc: "Likely duplicate uploads and versions that can be cleaned up." },
        cashFlowForecast: { title: "Cash-flow forecast", desc: "Expected incoming and outgoing cash for the next 13 weeks from invoice due dates." },
        receivableRisk: { title: "Receivable risk", desc: "Customers likely to pay late, based on payment history and balances." },
        invoiceAnomaly: { title: "Invoice anomalies", desc: "Unusual amounts, tax rates or duplicate invoice numbers." },
        approvalBottleneck: { title: "Approval bottlenecks", desc: "Where approvals wait longest and who is overloaded." },
        demandForecast: { title: "Demand forecast", desc: "Expected consumption per product from stock movement history." },
        deadStock: { title: "Dead and slow stock", desc: "Products with no movement and the value tied up in them." },
        reorderOptimization: { title: "Reorder optimization", desc: "Suggested minimum levels and order quantities." },
        warehouseUtilization: { title: "Warehouse utilization", desc: "How evenly stock and movements are spread across warehouses." },
        supplierRisk: { title: "Supplier risk", desc: "Suppliers with late deliveries, concentration or country risk." },
        priceAnomaly: { title: "Price anomalies", desc: "Purchase prices that differ from quotes and past orders." },
        spendAnalysis: { title: "Spend analysis", desc: "Where purchasing spend goes by supplier, currency and period." },
        salesForecast: { title: "Sales forecast", desc: "Expected order volume for the coming months." },
        customerChurn: { title: "Customer churn", desc: "Customers whose ordering has slowed down or stopped." },
        pricingInsight: { title: "Pricing insight", desc: "Discount and price patterns across orders." },
        capacityBottleneck: { title: "Capacity bottlenecks", desc: "Plans and orders that are likely to slip." },
        scrapAnalysis: { title: "Scrap analysis", desc: "Scrap rates by product and period, and their likely causes." },
        defectRootCause: { title: "Defect root causes", desc: "Recurring non-conformance patterns and suggested corrective actions." },
        qualityTrend: { title: "Quality trend", desc: "Inspection pass rates over time." },
        shipmentDelay: { title: "Shipment delays", desc: "Shipments likely to arrive late by route and mode." },
        customsCost: { title: "Customs cost", desc: "Duties and taxes by destination and how they change." },
        failurePatterns: { title: "Failure patterns", desc: "Common return and RMA reasons by product." },
        warrantyCost: { title: "Warranty cost", desc: "Warranty and service workload, and where it comes from." },
        processInsights: { title: "Process insights", desc: "How long workflows take and where they stall." },
        ticketTriage: { title: "Ticket triage", desc: "Grouping of support tickets by topic and urgency." }
      }
    }
  },
  tr: {
    aiAnalysis: {
      open: "AI analiz",
      title: "AI analiz",
      contextTitle: "AI analiz · {{module}}",
      hubTitle: "AI analiz",
      hubSubtitle: "Her modül için hazırlanmış analizler. Bir yapay zekâ sağlayıcısı bağlandığında çalışır.",
      module: "Modül",
      openHub: "Tüm AI analizleri",
      analyze: "Analiz et",
      privacy: "Yapay zekâya yalnızca toplu sayılar gönderilir; kayıt satırları, adlar ve iletişim bilgileri gönderilmez.",
      dataPreview: "Gönderilecek veri",
      showPayload: "İsteği göster",
      hidePayload: "İsteği gizle",
      loading: "Veri özeti hazırlanıyor…",
      loadError: "Bazı veriler yüklenemedi.",
      noData: "Henüz kayıt yok",
      records: "{{count}} kayıt",
      last30: "Son 30 gün: {{count}}",
      range: "{{from}} – {{to}}",
      byStatus: "Duruma göre",
      byGroup: "Gruba göre",
      status: {
        disabled: "AI bağlantısı bekleniyor",
        no_provider: "AI sağlayıcısı bağlı değil",
        no_consent: "AI veri işleme izni gerekli",
        ready: "Hazır"
      },
      statusDesc: {
        disabled: "AI analizleri hazır ama kapalı. Bir yönetici yapay zekâ sağlayıcısını bağladığında burada çalışacak.",
        no_provider: "AI analizleri açık, ancak henüz bir yapay zekâ sağlayıcısı bağlı değil.",
        no_consent: "Analiz çalıştırmak için Ayarlar'dan AI veri işleme iznini verin.",
        ready: "Analizler çalıştırılabilir."
      },
      admin: {
        title: "AI bağlantısı (yönetici)",
        switch: "AI analizlerini etkinleştir",
        hint: "Analizler yalnızca bu anahtar açıkken ve bir sağlayıcı bağlıyken çalışır. Henüz bağlı sağlayıcı yok.",
        provider: "Sağlayıcı",
        providerNone: "Bağlı değil",
        saved: "Ayar kaydedildi.",
        saveError: "Ayar kaydedilemedi."
      },
      modules: {
        dashboard: "Genel bakış",
        files: "Belgeler",
        accounting: "Muhasebe",
        inventory: "Stok ve depo",
        procurement: "Satın alma",
        sales: "Satış",
        manufacturing: "Üretim",
        quality: "Kalite",
        export: "İhracat",
        afterSales: "Satış sonrası",
        enterprise: "Kurumsal",
        support: "Destek"
      },
      datasets: {
        invoices: "Faturalar",
        accounts: "Cari hesaplar",
        approvals: "Onaylar",
        products: "Ürünler",
        stockMovements: "Stok hareketleri",
        warehouses: "Depolar",
        suppliers: "Tedarikçiler",
        purchaseOrders: "Satın alma siparişleri",
        rfqs: "Teklif talepleri",
        customers: "Müşteriler",
        salesOrders: "Satış siparişleri",
        productionPlans: "Üretim planları",
        manufacturingOrders: "Üretim emirleri",
        inspections: "Muayeneler",
        nonConformances: "Uygunsuzluklar",
        exportOrders: "İhracat siparişleri",
        internationalShipments: "Uluslararası sevkiyatlar",
        customsDeclarations: "Gümrük beyannameleri",
        returns: "İadeler",
        rmas: "RMA kayıtları",
        warranties: "Garantiler",
        serviceOrders: "Servis emirleri",
        files: "Dosyalar",
        supportTickets: "Destek talepleri"
      },
      fields: {
        totalAmount: "Toplam tutar",
        taxAmount: "Vergi",
        balance: "Bakiye",
        amount: "Tutar",
        currentStock: "Eldeki stok",
        costPrice: "Maliyet fiyatı",
        quantity: "Miktar",
        plannedQty: "Planlanan miktar",
        completedQty: "Tamamlanan miktar",
        scrappedQty: "Fire miktarı",
        dutiesAmount: "Gümrük vergisi",
        size: "Boyut (bayt)"
      },
      analyses: {
        executiveSummary: { title: "Yönetici özeti", desc: "Dönemin satış, satın alma, alacak ve stok durumunun sade bir özeti." },
        riskRadar: { title: "Risk radarı", desc: "Vadesi geçmiş faturalar, bekleyen onaylar ve açık kalite sorunları, etkisine göre sıralı." },
        documentInsights: { title: "Belge içgörüleri", desc: "Hangi tür belgeler geliyor, ne kadar hızlı işleniyor ve hangileri ilgi bekliyor." },
        duplicateDocuments: { title: "Mükerrer belgeler", desc: "Muhtemel mükerrer yüklemeler ve temizlenebilecek sürümler." },
        cashFlowForecast: { title: "Nakit akış tahmini", desc: "Fatura vadelerinden önümüzdeki 13 hafta için beklenen giriş ve çıkışlar." },
        receivableRisk: { title: "Alacak riski", desc: "Ödeme geçmişi ve bakiyelere göre geç ödeme olasılığı yüksek müşteriler." },
        invoiceAnomaly: { title: "Fatura anomalileri", desc: "Olağandışı tutarlar, vergi oranları ya da tekrarlanan fatura numaraları." },
        approvalBottleneck: { title: "Onay darboğazları", desc: "Onayların en uzun beklediği adımlar ve yükü fazla olan kişiler." },
        demandForecast: { title: "Talep tahmini", desc: "Stok hareketlerinden ürün bazında beklenen tüketim." },
        deadStock: { title: "Ölü ve yavaş stok", desc: "Hareketsiz ürünler ve bunlara bağlanan değer." },
        reorderOptimization: { title: "Yeniden sipariş önerisi", desc: "Önerilen asgari stok seviyeleri ve sipariş miktarları." },
        warehouseUtilization: { title: "Depo kullanımı", desc: "Stok ve hareketlerin depolar arasında ne kadar dengeli dağıldığı." },
        supplierRisk: { title: "Tedarikçi riski", desc: "Geç teslimat, yoğunlaşma veya ülke riski taşıyan tedarikçiler." },
        priceAnomaly: { title: "Fiyat anomalileri", desc: "Tekliflerden ve geçmiş siparişlerden sapan satın alma fiyatları." },
        spendAnalysis: { title: "Harcama analizi", desc: "Satın alma harcamasının tedarikçi, para birimi ve döneme göre dağılımı." },
        salesForecast: { title: "Satış tahmini", desc: "Önümüzdeki aylar için beklenen sipariş hacmi." },
        customerChurn: { title: "Müşteri kaybı", desc: "Sipariş vermesi yavaşlayan ya da duran müşteriler." },
        pricingInsight: { title: "Fiyatlama içgörüsü", desc: "Siparişlerdeki indirim ve fiyat örüntüleri." },
        capacityBottleneck: { title: "Kapasite darboğazları", desc: "Gecikme olasılığı yüksek plan ve emirler." },
        scrapAnalysis: { title: "Fire analizi", desc: "Ürün ve döneme göre fire oranları ve olası nedenleri." },
        defectRootCause: { title: "Hata kök nedenleri", desc: "Tekrarlayan uygunsuzluk örüntüleri ve önerilen düzeltici faaliyetler." },
        qualityTrend: { title: "Kalite eğilimi", desc: "Zaman içinde muayene geçme oranları." },
        shipmentDelay: { title: "Sevkiyat gecikmeleri", desc: "Rota ve taşıma şekline göre geç varması muhtemel sevkiyatlar." },
        customsCost: { title: "Gümrük maliyeti", desc: "Varış ülkesine göre gümrük vergileri ve değişimi." },
        failurePatterns: { title: "Arıza örüntüleri", desc: "Ürün bazında sık görülen iade ve RMA nedenleri." },
        warrantyCost: { title: "Garanti maliyeti", desc: "Garanti ve servis iş yükü ve kaynağı." },
        processInsights: { title: "Süreç içgörüleri", desc: "İş akışlarının ne kadar sürdüğü ve nerede takıldığı." },
        ticketTriage: { title: "Talep önceliklendirme", desc: "Destek taleplerinin konu ve aciliyete göre gruplanması." }
      }
    }
  },
  ar: {
    aiAnalysis: {
      open: "تحليل الذكاء الاصطناعي",
      title: "تحليل الذكاء الاصطناعي",
      contextTitle: "تحليل الذكاء الاصطناعي · {{module}}",
      hubTitle: "تحليل الذكاء الاصطناعي",
      hubSubtitle: "تحليلات مُعدّة لكل وحدة. تعمل بعد ربط مزوّد ذكاء اصطناعي.",
      module: "الوحدة",
      openHub: "جميع تحليلات الذكاء الاصطناعي",
      analyze: "تحليل",
      privacy: "تُرسل إلى الذكاء الاصطناعي أرقام إجمالية فقط؛ لا تُرسل سجلات أو أسماء أو بيانات اتصال.",
      dataPreview: "البيانات التي ستُرسل",
      showPayload: "عرض الطلب",
      hidePayload: "إخفاء الطلب",
      loading: "جارٍ إعداد ملخص البيانات…",
      loadError: "تعذر تحميل بعض البيانات.",
      noData: "لا توجد سجلات بعد",
      records: "{{count}} سجلات",
      last30: "آخر 30 يومًا: {{count}}",
      range: "{{from}} – {{to}}",
      byStatus: "حسب الحالة",
      byGroup: "حسب المجموعة",
      status: {
        disabled: "بانتظار ربط الذكاء الاصطناعي",
        no_provider: "مزوّد الذكاء الاصطناعي غير مرتبط",
        no_consent: "يلزم إذن معالجة البيانات بالذكاء الاصطناعي",
        ready: "جاهز"
      },
      statusDesc: {
        disabled: "تحليلات الذكاء الاصطناعي جاهزة لكنها متوقفة. ستعمل هنا عندما يربط المسؤول مزوّد ذكاء اصطناعي.",
        no_provider: "تحليلات الذكاء الاصطناعي مفعّلة، لكن لم يُربط أي مزوّد بعد.",
        no_consent: "امنح إذن معالجة البيانات بالذكاء الاصطناعي من الإعدادات لتشغيل التحليلات.",
        ready: "يمكن تشغيل التحليلات."
      },
      admin: {
        title: "ربط الذكاء الاصطناعي (المسؤول)",
        switch: "تفعيل تحليلات الذكاء الاصطناعي",
        hint: "تعمل التحليلات فقط عند تفعيل هذا المفتاح وربط مزوّد. لا يوجد مزوّد مرتبط بعد.",
        provider: "المزوّد",
        providerNone: "غير مرتبط",
        saved: "تم حفظ الإعداد.",
        saveError: "تعذر حفظ الإعداد."
      },
      modules: {
        dashboard: "نظرة عامة",
        files: "المستندات",
        accounting: "المحاسبة",
        inventory: "المخزون",
        procurement: "المشتريات",
        sales: "المبيعات",
        manufacturing: "التصنيع",
        quality: "الجودة",
        export: "التصدير",
        afterSales: "ما بعد البيع",
        enterprise: "المؤسسة",
        support: "الدعم"
      },
      datasets: {
        invoices: "الفواتير",
        accounts: "الحسابات",
        approvals: "الموافقات",
        products: "المنتجات",
        stockMovements: "حركات المخزون",
        warehouses: "المستودعات",
        suppliers: "الموردون",
        purchaseOrders: "أوامر الشراء",
        rfqs: "طلبات عروض الأسعار",
        customers: "العملاء",
        salesOrders: "أوامر البيع",
        productionPlans: "خطط الإنتاج",
        manufacturingOrders: "أوامر التصنيع",
        inspections: "الفحوصات",
        nonConformances: "حالات عدم المطابقة",
        exportOrders: "أوامر التصدير",
        internationalShipments: "الشحنات الدولية",
        customsDeclarations: "البيانات الجمركية",
        returns: "المرتجعات",
        rmas: "طلبات الإرجاع",
        warranties: "الضمانات",
        serviceOrders: "أوامر الخدمة",
        files: "الملفات",
        supportTickets: "تذاكر الدعم"
      },
      fields: {
        totalAmount: "المبلغ الإجمالي",
        taxAmount: "الضريبة",
        balance: "الرصيد",
        amount: "المبلغ",
        currentStock: "المخزون المتاح",
        costPrice: "سعر التكلفة",
        quantity: "الكمية",
        plannedQty: "الكمية المخططة",
        completedQty: "الكمية المنجزة",
        scrappedQty: "كمية الهالك",
        dutiesAmount: "الرسوم الجمركية",
        size: "الحجم (بايت)"
      },
      analyses: {
        executiveSummary: { title: "ملخص تنفيذي", desc: "ملخص مبسط للمبيعات والمشتريات والذمم والمخزون للفترة." },
        riskRadar: { title: "رادار المخاطر", desc: "فواتير متأخرة وموافقات معلقة ومشكلات جودة مفتوحة مرتبة حسب الأثر." },
        documentInsights: { title: "رؤى المستندات", desc: "أنواع المستندات الواردة وسرعة معالجتها وما يحتاج إلى متابعة." },
        duplicateDocuments: { title: "المستندات المكررة", desc: "عمليات رفع مكررة محتملة وإصدارات يمكن تنظيفها." },
        cashFlowForecast: { title: "توقع التدفق النقدي", desc: "التدفقات الداخلة والخارجة المتوقعة للأسابيع الـ13 القادمة من تواريخ استحقاق الفواتير." },
        receivableRisk: { title: "مخاطر الذمم المدينة", desc: "العملاء المرجح تأخرهم في السداد بناءً على السجل والأرصدة." },
        invoiceAnomaly: { title: "حالات شاذة في الفواتير", desc: "مبالغ أو نسب ضريبية غير معتادة أو أرقام فواتير مكررة." },
        approvalBottleneck: { title: "اختناقات الموافقات", desc: "أين تنتظر الموافقات أطول ومن لديه عبء زائد." },
        demandForecast: { title: "توقع الطلب", desc: "الاستهلاك المتوقع لكل منتج من سجل حركات المخزون." },
        deadStock: { title: "المخزون الراكد والبطيء", desc: "منتجات بلا حركة والقيمة المجمدة فيها." },
        reorderOptimization: { title: "تحسين إعادة الطلب", desc: "مستويات دنيا وكميات طلب مقترحة." },
        warehouseUtilization: { title: "استخدام المستودعات", desc: "مدى توازن توزيع المخزون والحركات بين المستودعات." },
        supplierRisk: { title: "مخاطر الموردين", desc: "موردون لديهم تأخر في التسليم أو تركّز أو مخاطر دولة." },
        priceAnomaly: { title: "حالات شاذة في الأسعار", desc: "أسعار شراء تختلف عن العروض والطلبات السابقة." },
        spendAnalysis: { title: "تحليل الإنفاق", desc: "توزيع إنفاق المشتريات حسب المورد والعملة والفترة." },
        salesForecast: { title: "توقع المبيعات", desc: "حجم الطلبات المتوقع للأشهر القادمة." },
        customerChurn: { title: "فقدان العملاء", desc: "عملاء تباطأت طلباتهم أو توقفت." },
        pricingInsight: { title: "رؤى التسعير", desc: "أنماط الخصومات والأسعار في الطلبات." },
        capacityBottleneck: { title: "اختناقات الطاقة", desc: "خطط وأوامر يُرجح تأخرها." },
        scrapAnalysis: { title: "تحليل الهالك", desc: "نسب الهالك حسب المنتج والفترة وأسبابها المحتملة." },
        defectRootCause: { title: "الأسباب الجذرية للعيوب", desc: "أنماط عدم المطابقة المتكررة والإجراءات التصحيحية المقترحة." },
        qualityTrend: { title: "اتجاه الجودة", desc: "نسب اجتياز الفحص عبر الزمن." },
        shipmentDelay: { title: "تأخر الشحنات", desc: "شحنات يُرجح وصولها متأخرة حسب المسار ووسيلة النقل." },
        customsCost: { title: "التكلفة الجمركية", desc: "الرسوم والضرائب حسب بلد الوجهة وتغيّرها." },
        failurePatterns: { title: "أنماط الأعطال", desc: "أسباب الإرجاع الشائعة حسب المنتج." },
        warrantyCost: { title: "تكلفة الضمان", desc: "عبء الضمان والخدمة ومصدره." },
        processInsights: { title: "رؤى العمليات", desc: "مدة سير العمل وأين يتوقف." },
        ticketTriage: { title: "فرز التذاكر", desc: "تجميع تذاكر الدعم حسب الموضوع والأولوية." }
      }
    }
  }
};
